import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { formatMessage, FormattedMessage } from 'translate';
import { CopyToClipboard } from '../../../_common';
import StyledLinkGeneration from './styles/LinkGeneration.styles';
import { getShareableLink } from '../../../../_core/utils';
import TwitterIcon from '../../../../icons/social/twitter_filled_white.svg';
import FacebookIcon from '../../../../icons/social/facebook_filled_white.svg';
import TelegramIcon from '../../../../icons/social/telegram_filled_white.svg';
import ShareIcon from '../../../../icons/social/share.svg';
import CopyIcon from '../../../../icons/wallet/copy.svg';
import CopyDesktop from '../../../../icons/copy_refer.svg';
import WarningIcon from '../../../../icons/wallet/warning_green.svg';
import { popupCenter } from '../../../../2key_modules/utils';

const ShareOptions = ({
  isMobile,
  arcsQuotaPerReferrer,
  referralHash,
}) => {
  const referralLink = referralHash.startsWith('http') ? referralHash : `${window.location.origin}/${referralHash}`;
  const handleOpenWindow = useCallback(({ currentTarget: { dataset } }) => {
    const { social, hash: publicLink } = dataset;

    popupCenter(
      getShareableLink(social, publicLink, formatMessage({ id: 'campaign.share_link_message' })),
      social, 500, 500
    );
  }, [referralHash]);

  const mobileShareAction = useCallback(() => {
    if (navigator.share) {
      navigator.share({
        title: '2key.net',
        text: 'I think this campaign will interest you! check it out-',
        url: referralLink,
      });
    }
  }, [referralHash]);

  return (
    <StyledLinkGeneration isMobile={isMobile}>
      <div className={`generated-links ${(arcsQuotaPerReferrer && (arcsQuotaPerReferrer !== 1000000000))
        ? 'with-divider'
        : ''}`}
      >
        <div className="generated-links-title">
          <FormattedMessage id="campaign_pay_it_forward.share_link_title" />
        </div>
        {(!isMobile || navigator.share) ?
          <div className="generated-links-list">
            <button
              className="link twitter"
              data-social="twitter"
              data-hash={referralLink}
              onClick={handleOpenWindow}
            >
              <img src={TwitterIcon} alt="twitter_filled_white.svg" />
            </button>
            <button
              className="link facebook"
              data-social="facebook"
              data-hash={referralLink}
              onClick={handleOpenWindow}
            >
              <img src={FacebookIcon} alt="facebook_filled_white.svg" />
            </button>
            <button
              className="link telegram"
              data-social="telegram"
              data-hash={referralLink}
              onClick={handleOpenWindow}
            >
              <img src={TelegramIcon} alt="telegram_filled_white.svg" />
            </button>
          </div> :
          <button className="share-mobile" onClick={mobileShareAction}>
            <img src={ShareIcon} alt="share.svg" />
          </button>}
        <CopyToClipboard className={`copy-link ${!isMobile ? 'desktop' : ''}`} value={referralLink}>
          {isMobile && <img src={CopyIcon} alt="copy.svg" />}
          {!isMobile ? (
            <img src={CopyDesktop} alt="copy.svg" />) :
            (<FormattedMessage id="main.copy" />)}
        </CopyToClipboard>
      </div>
      {(arcsQuotaPerReferrer && (arcsQuotaPerReferrer !== 1000000000)) &&
        <div className="notification">
          <img src={WarningIcon} alt={WarningIcon} />
          <span>
            <FormattedMessage id="campaign_pay_it_forward.can_join" values={{ usersNumber: arcsQuotaPerReferrer }} />
          </span>
        </div>}
    </StyledLinkGeneration>
  );
};

ShareOptions.propTypes = {
  isMobile: PropTypes.bool,
  arcsQuotaPerReferrer: PropTypes.number,
  referralHash: PropTypes.string,
};

export default memo(ShareOptions);
